import { render, staticRenderFns } from "./RoleGrid.vue?vue&type=template&id=58a77b86&scoped=true"
import script from "./RoleGrid.vue?vue&type=script&lang=js"
export * from "./RoleGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a77b86",
  null
  
)

export default component.exports